import React from 'react';
import { useT } from '../i18n';
export function Footer() {
  const {
    t
  } = useT();
  return <footer className="w-full py-4 text-center" data-id="element-45">
      <p className="text-xs text-white/40 font-body tracking-wide" data-id="element-46">
        {t('footer')}
      </p>
    </footer>;
}